import { Label, Text } from "@fluentui/react";
import { RootState } from "app/store";
import { textProp } from "global/Application";
import * as IXrmTypes from "model/CRM";
import * as FAM from "model/FlexibleAttributeModel";
import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import LookupControlBase from "./LookupControlBase";
import LookupControlDialog from "./LookupControlDialog";


interface IProps extends TComponentConnectedProps {
    label?: string;
    defaultFieldValue?: FAM.IEntityReferenceValue;
    disabled?: boolean;
    masterAttribute?: IXrmTypes.bcbs_config_masterattribute

    // if they can manually type in lookup
    freeForm?: boolean;

    fieldValueOnChange?: (event: any, value: FAM.IEntityReferenceValue | null) => void;

    attribute?: IXrmTypes.bcbs_config_attribute
}


const LookupControl: React.FC<IProps> = (props) => {
    const [lookupIsOpen, setLookupIsOpen] = useState(false);

    const [value, setValue] = useState<FAM.IEntityReferenceValue | null>(
        props.defaultFieldValue
            ? props.defaultFieldValue
            : null
    );

    const fieldValueOnChange = (value: FAM.IEntityReferenceValue | null) => {
        setValue(value);
        props.fieldValueOnChange?.(null, value);
    }

    return <div>
        {lookupIsOpen &&
            <LookupControlDialog
                isOpen={lookupIsOpen}
                onDismiss={() => setLookupIsOpen(false)}
                variant="single"
                label={props.label}
                masterAttribute={props.masterAttribute}
                attribute={props.attribute}
                onPick={(event) => {
                    if (event && event.length === 1) {
                        fieldValueOnChange(event[0] as FAM.IEntityReferenceValue);
                    }
                    setLookupIsOpen(false);
                }}

            />
        }

        <LookupControlBase
            label={props.label}
            disabled={props.disabled}
            onLookup={() => setLookupIsOpen(true)}
            onDelete={() => { fieldValueOnChange(null) }}
            value={value?.name}
            valueEntityReference={value ?? undefined}
        />
    </div>
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(LookupControl)
